let echartsPromise;

const loadEcharts = () => {
  if (typeof window !== "undefined" && window.echarts) {
    return Promise.resolve(window.echarts);
  }
  if (!echartsPromise) {
    echartsPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector("script[data-echarts]");
      if (existing) {
        existing.addEventListener("load", () => resolve(window.echarts));
        return;
      }
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/echarts@5.5.1/dist/echarts.min.js";
      script.async = true;
      script.dataset.echarts = "true";
      script.onload = () => resolve(window.echarts);
      script.onerror = () => reject(new Error("ECharts failed to load"));
      document.body.appendChild(script);
    });
  }
  return echartsPromise;
};

export default loadEcharts;
